module.exports = __webpack_public_path__ + "65c7f51f9933e55962c1c2c975b379e3.ttf";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-brands-400.ttf
// module id = 347
// module chunks = 0